import { Pipe, PipeTransform } from '@angular/core';

/**
 * truncate text
 *
 * ## Ussage
 *
 * {{ str | truncate:20 }} // or
 * {{ str | truncate:20 : '...' }}
 *
 */

@Pipe({
    name: 'truncate',
    standalone: true
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, length?: number, suffix = '', preserve = false) {
        length = typeof length === 'number' ? length : value.length;
        if (typeof value !== 'string' || (length && value.length <= length)) {
            return value;
        }
        return (
            value.substring(0, preserve ? (value.indexOf(' ', length) === -1 ? value.length : value.indexOf(' ', length)) : length) + suffix
        );
    }
}
